import { IGroupSeason } from "./../../entities";
import { provider } from "../../providers";

export interface GetGroupSeasonsPayload {
  groupId: number;
}

export const GetGroupSeasons = async (params: GetGroupSeasonsPayload): Promise<IGroupSeason[]> =>
  provider.Request("/groups/{groupId}/seasons", params);
